module.exports = __webpack_public_path__ + "static/img/2.42637a6a.png";